<template>
    <div class="decorationList">
      <ul class="listGroup">
        <li class="aaa" v-if="unprocessedFlag"  v-for="item in unprocessedList" :key="item.index" >
          <p class="content"><span class="c333">施工单位:</span><span class="c999">{{item.buildermemo}}</span></p>
          <p class="content"><span class="c333">施工负责人:</span><span class="c999">{{item.builderresponsermemo}}</span></p>
          <p class="content"><span class="c333">计划开始时间:</span><span class="c999">{{item.buildebegindate}}</span></p>
          <p class="content"><span class="c333">计划终止时间:</span><span class="c999">{{item.buildetenddate}}</span></p>
          <p class="content"><span class="c999 "> <span class="mr10">上报日期:</span>{{item.prepareddate}}</span> <span :class="item.billstate==='未通过'?'noPass':'pass'">{{item.billstate}}</span></p>
        </li>
      </ul>
      <div :class="loadMoreHide ? 'load-more-hide' : 'load-more-normal'" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
        <span v-show="loadingShow">加载中...</span>
        <span v-show="tipsShow">暂无数据</span>
      </div>
    </div>
</template>

<script>
    export default {
        name: "decorationList",
      data(){
          return {
            busy: false,
            loadMoreHide:false,
            loadingShow:false,
            tipsShow: false,
            unprocessedFlag: true,
            unprocessedList:[],
            urlN9: '',
            pk_house: '',
            size: 4,
            page: 0,
          }
      },
      mounted(){
        // this.initList(false);
      },
      methods:{
          //初始化列表
        initList(flag){
          let _this = this;
          _this.postRequest('house/querydecoratelist',{
            page: _this.page,
            size: _this.size,
          },function (data) {
            console.log(data)
            if(flag){
              _this.unprocessedList = _this.unprocessedList.concat(data.datas)
                _this.busy = data.datas.length === 0;
              if(data.datas.length === 0)_this.tipsShow = true
              if(_this.page < data.pages){
                _this.busy = false
              }else{
                _this.busy = true
                _this.loadingShow = false
                _this.tipsShow = false
              }
            }else{
              _this.unprocessedList = data.datas
            }
          })
        },
        // 多次加载数据
        loadMore () {
          if(this.page === 0){
            this.busy = true
            this.tipsShow = true
            this.page++
            this.initList(true);
          }else{
            this.busy = true
            this.loadingShow = true
            this.page++
            this.initList(true);
          }
        },
      }
    }
</script>

<style scoped>
  .decorationList{
    background-color: #f2f2f2;
  }
  .listGroup{
    background-color: #f2f2f2;
    padding-top: .5rem;
    box-sizing: border-box;
  }
  .aaa{
    background-color: #fff;
    width: 94%;
    padding: 0.3rem .3rem;
    box-sizing: border-box;
    margin: 0 auto .5rem;
    border-radius: .1rem;
  }
  .aaa .content{
    height: .8rem;
    display: flex;
    justify-content: space-between;
  }
  .mr10{
    margin-right: .2rem;
  }
  .pass{
    color: green;
    font-size: .4rem;
  }
  .noPass{
    color: red;
    font-size: .4rem;
  }
  .c333{
    font-size: .5rem;
    color: #333;
  }
  .c999{
    color: #999;
    font-size: .4rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/pub-component/decoration/decorationList.vue